export default __webpack_public_path__ + "mixed-content-light.1a2a29a5.svg";